import { ERRORS } from "~/assets/constants";
import type { AppError as AppErrorType } from "~/types";

export class AppError extends Error {
  override message: AppErrorType = 'server';
  constructor(message: AppErrorType) {
    super(message);
    this.message = message;
  }
}

export function isAppError(msg: string): msg is AppErrorType {
  return ERRORS.includes(msg as AppErrorType);
}